const IconHamburgerMenu = (): JSX.Element => {
  return (
    <>
      <rect x="12" y="16.5" width="24" height="2.5" rx="1.25" fill="currentColor" />
      <rect x="12" y="23.5" width="24" height="2.5" rx="1.25" fill="currentColor" />
      <rect x="12" y="30.5" width="24" height="2.5" rx="1.25" fill="currentColor" />
    </>
  );
};

export default IconHamburgerMenu;
